import List from './list.element.js';

export default List;

List.define('wje-list', List);
